import { ToastContainer } from 'react-toastify'
import { TableSection } from '../../components/TableSection/TableSection'
import { CardDashboard } from '../../components/CardDashboard/CardDashboard'
import { Container, WrapperCards, WrapperTop } from './DashBoard.style'
import { Div } from '../../components/TableSection/TableSection.style'
import { colors } from '../../theme'
import { EveryUser } from '../../assets/icons/every-user'
import { ChevronRight } from '../../assets/icons/chevron right'
import { FacialBlueIcon } from '../../assets/icons/FacialBlue'
import { Tour } from '../../components/Tour'
import TourDashboard from '../../utils/JoyRide/tourDashboard'

const produtos = [
  {
    id: 1,
    produto: 'Selecione a Organização',
    percent: '100',
  },
]

export function DashboardOrganization() {
  const changeStateProducts = () => ''
  const changeStateClients = () => ''

  return (
    <>
      <ToastContainer theme="dark" />
      <Container id="dashboard">
        <WrapperTop id="finalizacao">
          Dashboard
          <Tour steps={TourDashboard} />
        </WrapperTop>
        <WrapperCards id="saudacao">
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.surfaceHigh}
            total={100}
            percentage={100}
            percentageGraphic={100}
          >
            Total <strong>produtos</strong> em alta
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.surfaceHigh}
            total={100}
            percentage={100}
            percentageGraphic={100}
          >
            Total <strong>produtos</strong> em baixa
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.surfaceHigh}
            total={100}
            percentage={100}
            percentageGraphic={100}
          >
            Total <strong>cliente</strong> em alta
          </CardDashboard>
          <CardDashboard
            colorTitle={colors.white}
            color={colors.white}
            background={colors.surfaceHigh}
            total={100}
            percentage={100}
            percentageGraphic={100}
          >
            Total <strong>cliente</strong> em baixa
          </CardDashboard>
        </WrapperCards>
      </Container>
      <Div id="table">
        <TableSection
          isOnHigh
          changeValue={changeStateProducts}
          title="Produtos"
          icon={<FacialBlueIcon />}
          background={`${colors.azul1}`}
          headers={['ID', 'Produto', 'Percentual', '']}
          isLoading={false}
        >
          {produtos.map(item => (
            <tr
              id="itemProduto"
              className="itemTable"
              onClick={() => item.id}
              key={item.id}
            >
              <td>{item.id}</td>
              <td className="col2">{item.produto}</td>
              <td>{item.percent}%</td>
              <td>
                <ChevronRight />
              </td>
            </tr>
          ))}
        </TableSection>
        <TableSection
          isLoading={false}
          isOnHigh
          changeValue={changeStateClients}
          title="Clientes"
          icon={<EveryUser />}
          background={`${colors.grey200}`}
          headers={['ID', 'Cliente', 'Percentual', '']}
        >
          {produtos.map(item => (
            <tr
              id="itemCliente"
              className="itemTable"
              onClick={() => item.id}
              key={item.id}
            >
              <td>{item.id}</td>
              <td className="col2">{item.produto}</td>
              <td>{item.percent}%</td>
              <td>
                <ChevronRight />
              </td>
            </tr>
          ))}
        </TableSection>
      </Div>
    </>
  )
}
